<template>
  <div>
    <v-dialog v-model="dialog.form"
      @keydown.esc="dialog.form = false"
      :fullscreen="dialog.fullscreen"
      width="650"
      persistent
      scrollable>
      <v-card class="border-radius pa-2">
        <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
          <v-avatar size="35">
            <v-img
              contain
              width="30"
              height="30"
              alt="vuetify"
              :src="require('@/assets/logo/favicon.png')">
              <template v-slot:placeholder>
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center">
                  <v-progress-circular 
                    indeterminate 
                    color="#ff64ad">
                  </v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>

          <span class="mt-1 ml-1">
            Ubah Layanan
          </span>

          <v-spacer/>

          <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#ff64ad">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.form = false"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon>
        </v-card-title>

        <v-divider class="mx-4 mt-3 mb-2"/>

        <v-card-text 
          class="pt-2 body-1 line-text-second">
          <ValidationObserver ref="form">
            <v-form class="text-left">
              <div class="mb-6">
                <div class="body-2 mb-2">
                  <span>*</span>
                  Gambar
                  <span>
                    (boleh dikosongi)
                  </span>
                </div>

                <uploadfolder 
                  v-model="upload.folder" 
                  style="width: 175px; height: 175px;">
                  <div slot="activator" class="cursor-pointer">
                    <v-card 
                      flat
                      width="175"
                      height="175"
                      class="d-flex align-center justify-center"
                      style="border-radius: 15px;
                            border: 2px solid #eaeaea; 
                            border-style: dashed;">
                      <div v-if="form.image.length < 1">
                        <v-icon v-if="!process.image"
                          size="60" 
                          color="grey">
                          mdi-cloud-upload-outline
                        </v-icon>

                        <v-progress-circular v-else
                          indeterminate
                          color="#ff64ad">
                        </v-progress-circular>
                      </div>

                      <v-img v-else
                        contain
                        width="175"
                        height="175"
                        :src="form.image.length > 0 ? form.image : require('@/assets/image/member-default.jpg')" 
                        gradient="to top right, rgba(0,0,0,.2), rgba(0,0,0,.2)"
                        :alt="form.image"
                        class="text-center d-flex align-center">
                        <div class="d-flex aling-center justify-center" style="width: 100%; height: auto;">
                          <v-icon size="60" color="white">mdi-cloud-upload-outline</v-icon>
                        </div>
                      </v-img>
                    </v-card>
                  </div>
                </uploadfolder>
              </div>

              <div class="mb-6">
                <div class="body-2 mb-2">
                  <span>*</span>
                  Keterangan
                  <span>
                    (boleh dikosongi)
                  </span>
                </div>

                <quill-editor 
                  ref="myTextEditor"
                  :options="{
                    placeholder: 'Contoh. Foto / Scan bukti keterangan sudah perekaman, bagi yang hendak melakukan pengajuan baru.'
                  }"
                  v-model="form.desc">
                </quill-editor>
              </div>

              <!-- <div>
                <div class="body-2 mb-2">
                  <span>*</span>
                  Jenis Ajuan
                  <span>
                    (boleh dikosongi)
                  </span>
                </div>

                <v-select
                  v-on:keyup.enter="save"
                  multiple
                  outlined
                  dense
                  color="#ff64ad"
                  placeholder="Contoh. Perubahan Data"
                  
                  :items="list.ajuan"
                  item-text="ja_judul"
                  item-value="ja_id"
                  item-color="#ff64ad"

                  hide-details

                  v-model="form.jenis_ajuan_id_list">
                </v-select>
              </div> -->

              <ValidationProvider 
                name="jenis_ajuan_id_list" 
                rules="required" 
                v-slot="{ errors, valid }">
                <div class="body-2 mb-2">
                  <span class="red--text">*</span>
                  Jenis Ajuan
                  <span class="error--text">
                    (wajib diisi)
                  </span>
                </div>

                <v-select
                  v-on:keyup.enter="save"
                  multiple
                  outlined
                  dense
                  color="#ff64ad"
                  placeholder="Contoh. Perubahan Data"
                  
                  :items="list.ajuan"
                  item-text="ja_judul"
                  item-value="ja_id"
                  item-color="#ff64ad"

                  hide-details

                  v-model="form.jenis_ajuan_id_list"
                  :success="form.jenis_ajuan_id_list.length > 0 && valid"
                  :error-messages="errors"
                  required>
                  <template v-slot:append-outer>
                    <div v-if="errors.length > 0">
                      <v-tooltip top color="#ff5252">
                        <template v-slot:activator="{ on }">
                          <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                        </template>
                        
                        Jenis Ajuan {{ errors[0] }}
                      </v-tooltip>
                    </div>

                    <div v-if="form.jenis_ajuan_id_list.length > 0 && valid">
                      <v-icon color="success">mdi-check-circle-outline</v-icon>
                    </div>
                  </template>
                </v-select>
              </ValidationProvider>

              <div class="my-6">
                <div class="body-2 mb-2">
                  <span>*</span>
                  Catatan Penting
                  <span>
                    (boleh dikosongi)
                  </span>
                </div>

                <quill-editor 
                  ref="myTextEditor"
                  :options="{
                    placeholder: 'Contoh. Lampiran khusus surat persetujuan apabila kontrak / kost.'
                  }"
                  v-model="form.extra.note">
                </quill-editor>
              </div>
            </v-form>
          </ValidationObserver>

          <v-alert 
            type="error" 
            text dense prominent 
            class="mt-6"
            v-show="message.error.length > 0">
            {{  message.error }}
          </v-alert>
        </v-card-text>

        <v-divider class="mx-4 mb-3 mt-0"/>

        <v-card-actions>
          <v-spacer/>

          <v-btn
            color="#ff64ad"
            elevation="0"
            class="body-2 font-weight-bold text-capitalize white--text"
            :disabled="process.form"
            :loading="process.form"
            v-on:keyup.enter="save()"
            @click="save()">
            <v-icon small class="mr-1">mdi-check-bold</v-icon>
            Simpan
          </v-btn>

          <v-btn
            outlined
            class="body-2 font-weight-bold text-capitalize red--text"
            :disabled="process.form"
            @click="dialog.form = false">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Batal
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout wrap>
      <v-flex>
        <section>
          <v-card 
            flat 
            style="border: 1px solid #E0E0E0;">
            <v-card-text>
              <v-row>
                <v-col cols="12" md="8" class="d-flex align-center">
                  <!-- EDIT -->
                  <div class="mr-3">
                    <v-btn v-if="selected.row.length === 1"
                      elevation="0"
                      style="background: #2196f333;"
                      class="body-2 text-capitalize font-weight-bold d-flex align-center blue--text"
                      @click="dialog.form = true; detail = selected.row[0]; reset();">
                      <v-icon size="18">mdi-circle-edit-outline</v-icon>

                      <span class="ml-1">
                        Ubah
                      </span>
                    </v-btn>
                  </div>
                </v-col>

                <v-col cols="12" md="4" class="d-flex align-center justify-end">
                  <v-text-field 
                    class="mr-3"
                    dense
                    single-line
                    hide-details
                    color="#ff64ad"
                    placeholder="Cari . . ."
                    append-icon="mdi-magnify"
                    clearable
                    v-model="search"
                    v-uppercase
                    @click:clear="search = ''; fetch();"
                    v-on:keyup.enter="fetch()">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <v-data-table
              v-model="selected.row"
              ref="table-grid"
              class="table-grid"
              :height="`calc(100vh - ${pagination.total_data > 0 ? '344px' : '272px'})`"
              :show-select="true"
              :single-select="true"
              :loading="process.load"
              loading-text="Sedang memuat data . . ."
              loader-height="5"
              no-results-text="Belum ada data"
              :options.sync="options"
              :headers="headers"
              :items="list.data"
              :items-per-page="100"
              item-key="id"
              @click:row="rowClick"
              @toggle-select-all="handleToggleAll($event)"
              hide-default-footer>
              <template v-slot:[`item.index`]="{ index }">
                {{ lastIndex + index }}
              </template>

              <v-progress-linear 
                v-show="process.load" 
                slot="progress" 
                color="white" 
                indeterminate>
              </v-progress-linear>
            </v-data-table>

            <pagination v-if="pagination.total_data > 0"
              @changePage="fetch($event)" 
              @reloadPage="fetch($event)" 
              :model="pagination"/>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        show: false,
        dialog: {
          snackbar: false,
          fullscreen: false,
          form: false
        },
        search: '',
        selected: {
          row: []
        },
        options: {},
        headers: [],
        detail: {},
        list: {
          data: [],
          ajuan: []
        },
        limit: 20,
        pagination: {},
        lastIndex: 0,
        upload: {
          folder: null
        },
        form: {
          id: '',
          desc: '',
          image: '',
          jenis_ajuan_id_list: [],
          extra: {
            note: ''
          }
        },
        process: {
          load: false,
          form: false,
          image: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue'),
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          this.fetch(pagination)
        },
        deep: true
      },
      'upload.folder': {
        handler: function () {
          if (this.upload.folder) {
            this.process.image = this.upload.folder.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE
              this.form.image = this.upload.folder.data.full.file_url
            }
          }
        },
        deep: true
      },
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    mounted () {
      this.fetch()
    },
    methods: {
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },
      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? 'id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'DESC' : 'ASC',
          search: this.search,
          // list_type: 'short',
          auth_role: 1
        }

        this.selected.row = []

        await get('layanan', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.code === 200) {
            this.headers = [
              {
                text: '#No',
                width: '75px',
                value: 'index',
                sortable: false,
                freeze: true,
                hide: false,
                align: 'center'
              },
              {
                text: 'Nama Layanan',
                width: '200px',
                value: 'layanan_nama',
                freeze: false,
                hide: false
              },
              {
                text: 'Kode Layanan',
                width: '100px',
                value: 'layanan_kode',
                freeze: false,
                hide: false
              }
            ]
            
            this.list.data = res.data
            this.pagination = res.pagination

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1
          }
        })
      },
      async fetchAjuan () {
        await get('jenis_ajuan')
        .then(response => {
          let res = response.data

          if (res.code === 200) {
            this.list.ajuan = res.data
          }
        })
      },
      reset () {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: this.detail.id,
          desc: this.detail.layanan_desc,
          image: this.detail.layanan_image,
          jenis_ajuan_id_list: this.detail.layanan_jenis_ajuan_id_list !== ''  ? this.detail.layanan_jenis_ajuan_id_list.split(',').map(obj => Number(obj)) : this.detail.layanan_jenis_ajuan_id_list,
          extra: this.detail.layanan_extra
        }
        
        this.process.form = false

        this.message.error = ''

        this.fetchAjuan()
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {

          this.process.form = true

          this.form.jenis_ajuan_id_list = this.form.jenis_ajuan_id_list.toString()

          // SAVE TO REST API
          await post('layanan/update', {
            data: this.form
          })
          .then(response => {
            let res = response.data

            this.process.form = false

            if (res.code === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true

              this.message.success = res.message

              this.fetch()
            } else {
              this.form.jenis_ajuan_id_list = this.form.jenis_ajuan_id_list !== ''  ? this.form.jenis_ajuan_id_list.split(',').map(obj => Number(obj)) : this.form.jenis_ajuan_id_list
              
              this.message.error = res.message
            }
          })
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>